import * as React from 'react';
import Constants from 'src/helper/Constants';
import System from "src/helper/system";

const ThankYouPopup = (props) => {
    const { translation:t } = System;
    const { SetStatus, data } = props;
    const getTitleText = () => {
        if (data.isOrderHistory) {
            return t('thanksForYourRequest');
        }
        if (data?.isRegister) {
            return t('thankYou');
        }
        if (data?.isPDPShare) {
            return t('messageSent');
        }
        if (data?.isAccountInActive) {
            return 
        }
        return t('feedbackReceived');
    }
    const getBodyText = () => {
        if (data.isPDP) {
            return t('feedbackReceivedExpertsReview')
        }
        if (data.isPDPShare) {
            return t('yourEmailHasBeenSent') +'.'
        }
       if (data.isOrderHistory) {
            return t('orderHistoryDetailsEmail')
        }
        if (data.isAccountInActive) {
            return (
                <p>
                    {t('accountInactiveUnableToOrder')} <a href="mailto:CMD@Avnet.com" className='text-blue2'>CMD@Avnet.com</a> {t('forMoreInformation')}
                </p>
            )
        }
        if (data?.isRegister) {
            return (
                System.getCurrentRegionWithType(Constants.speedBoats.apacAbbr) ? (
                    <p>
                        {t('tempPasswordEmailSupport')}:  <br /> {t('onlineSupportAsiaPhone')}: 86-755-2184-5922 {t('or')} <a href="mailto:OnlineSupport-Asia@avnet.com" className='text-decoration-underline'>OnlineSupport-Asia@avnet.com</a>
                    </p>
                ) :
                    <p>
                        {t('tempPasswordEmailSupport')}: <a href="mailto:OnlineSupport-Japan@avnet.com" className='text-decoration-underline'>OnlineSupport-Japan@avnet.com</a>
                    </p>
            )
        }
        return t('yourEmailHasBeenSent') + '.'
    }

    const getFooterButtonText = () => {
        if (data?.isOrderHistory || data?.isPDPShare) {
            return t('close')
        }
        if (data?.isRegister) {
            return t('continue');
        }
        if (data?.isAccountInActive) {
            return t('close')
        }
        return 'OK';
    }
    return (
        <>
            <div className={`avnet-modal ${data?.isOrderHistory ? 'modal-500' : 'modal-630'} `}>
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    {!data?.isRegister && (

                        <button type="button" className="close" data-dismiss="modal"
                            onClick={() => {
                                SetStatus(false)
                            }}>
                        </button>
                    )}
                    <div className="modal-header justify-content-center">
                        <h1 className="pcn-modal-heading">
                            {data?.isRegister ?
                                <span className='text-darkgreen'>{getTitleText()} </span>
                                : getTitleText()}
                        </h1>
                    </div>
                    {/* Modal body */}
                    <div className="modal-body">
                        <div className="text-center mb-3">
                            {getBodyText()}
                        </div>
                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer text-center">
                        <div className="modal-footer-actions">
                            <button type="button" className={`bs5 btn ${data?.isOrderHistory ? 'btn-secondary btn-sm w145' : 'btn-primary minw-auto'} ${(data?.isRegister || data?.isAccountInActive) && 'text-upperase'}`}
                                onClick={() => {
                                     if (data?.isRegister) {
                                         window.location.href = System.getPreviousPageUrl()
                                     } else {
                                         SetStatus(false)
                                     }
                                }}
                            >
                                {getFooterButtonText()}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ThankYouPopup;